import { UserRole } from '@shared/models';

export interface UserRoleDetails {
  readonly icon: string;
  readonly labelSuffix?: string;
  readonly descriptionKey: string;
  readonly priceKey: string;
  readonly billingKey: string;
  readonly badgeClass: string;
}

export const USER_ROLE_DETAILS: Readonly<Record<UserRole, UserRoleDetails>> = {
  [UserRole.None]: {
    icon: 'pi pi-user',
    descriptionKey: 'admin.users.roleSelector.descriptions.none',
    priceKey: 'admin.users.roleSelector.pricing.notApplicable',
    billingKey: 'admin.users.roleSelector.billing.notApplicable',
    badgeClass: 'bg-surface-200 text-muted-color',
  },
  [UserRole.Ceo]: {
    icon: 'pi pi-crown',
    descriptionKey: 'admin.users.roleSelector.descriptions.ceo',
    priceKey: 'admin.users.roleSelector.pricing.paidSeat',
    billingKey: 'admin.users.roleSelector.billing.perMonth',
    badgeClass: 'bg-primary-100 text-primary-700',
  },
  [UserRole.ProjectManager]: {
    icon: 'pi pi-briefcase',
    descriptionKey: 'admin.users.roleSelector.descriptions.projectManager',
    priceKey: 'admin.users.roleSelector.pricing.paidSeat',
    billingKey: 'admin.users.roleSelector.billing.perMonth',
    badgeClass: 'bg-primary-100 text-primary-700',
  },
  [UserRole.Foreman]: {
    icon: 'pi pi-wrench',
    descriptionKey: 'admin.users.roleSelector.descriptions.foreman',
    priceKey: 'admin.users.roleSelector.pricing.seatBased',
    billingKey: 'admin.users.roleSelector.billing.perMonth',
    badgeClass: 'bg-surface-200 text-muted-color',
  },
  [UserRole.Worker]: {
    icon: 'pi pi-mobile',
    descriptionKey: 'admin.users.roleSelector.descriptions.worker',
    priceKey: 'admin.users.roleSelector.pricing.free',
    billingKey: 'admin.users.roleSelector.billing.free',
    badgeClass: 'bg-green-100 text-green-700',
  },
  [UserRole.Agent]: {
    icon: 'pi pi-headphones',
    descriptionKey: 'admin.users.roleSelector.descriptions.agent',
    priceKey: 'admin.users.roleSelector.pricing.internal',
    billingKey: 'admin.users.roleSelector.billing.internal',
    badgeClass: 'bg-surface-200 text-muted-color',
  },
  [UserRole.LearningManager]: {
    icon: 'pi pi-graduation-cap',
    descriptionKey: 'admin.users.roleSelector.descriptions.learningManager',
    priceKey: 'admin.users.roleSelector.pricing.internal',
    billingKey: 'admin.users.roleSelector.billing.internal',
    badgeClass: 'bg-surface-200 text-muted-color',
  },
  [UserRole.HR]: {
    icon: 'pi pi-users',
    labelSuffix: ' (Beta)',
    descriptionKey: 'admin.users.roleSelector.descriptions.hr',
    priceKey: 'admin.users.roleSelector.pricing.beta',
    billingKey: 'admin.users.roleSelector.billing.beta',
    badgeClass: 'bg-purple-100 text-purple-700',
  },
  [UserRole.Stakeholder]: {
    icon: 'pi pi-eye',
    descriptionKey: 'admin.users.roleSelector.descriptions.stakeholder',
    priceKey: 'admin.users.roleSelector.pricing.seatBased',
    billingKey: 'admin.users.roleSelector.billing.perMonth',
    badgeClass: 'bg-surface-200 text-muted-color',
  },
  [UserRole.Admin]: {
    icon: 'pi pi-shield',
    descriptionKey: 'admin.users.roleSelector.descriptions.admin',
    priceKey: 'admin.users.roleSelector.pricing.internal',
    billingKey: 'admin.users.roleSelector.billing.internal',
    badgeClass: 'bg-surface-200 text-muted-color',
  },
};
